import React from 'react'
import '../assets/css/About.styl'
function About() {
        return (
            <div className="about flex-justify-center flex-column">
               <div className="banner flex-items-center flex-justify-center bold">
               </div>
               <div className="flex-column flex-items-center">
                    <div className="about-title fs-36 mt-36 bold">
                        <div className="tit">
                            关于我们
                        </div>
                    </div>
                    <div className="about-content fs-24 text-center">
                        <div>
                        宁波小鹿快跑科技有限公司
                        </div>
                        <div className="mt-30">
                        联系电话：18401727012（周一至周日，10:00-18:00）
                        </div>
                        <div className="mt-30">
                        联系地址：浙江省宁波市大榭开发区滨海南路111号西楼A1746-6室
                        </div>
                    </div>
               </div>
            </div>
        );
    }
export default About;